/**
 * Represents the animated menu icon
 */
export class NavbarMenuIcon {
    /**
     * Initizalize an instance of NavbarMenuIcon
     */
    constructor(idMenu, openDrawer, menuOpened) {
        /**
         * Represents the id of the Html Element menu
         */
        this.idMenu = '';
        this.opened = menuOpened;
        this.idMenu = idMenu;
        this.openDrawer = openDrawer;
        if (menuOpened)
            this.openDrawer();
    }
    /**
     * Create the custom component
     * @returns HTML code of the component
     */
    Render() {
        const menuElement = document.createElement('div');
        menuElement.innerHTML = this.menuIcon();
        const menuBtn = menuElement.querySelector('.menu-btn');
        if (this.opened && menuBtn) {
            menuBtn.classList.add('open');
        }
        menuElement.addEventListener('click', () => this.toggleIconAndOpenDrawer());
        return menuElement;
    }
    /**
     * It returns a string that contains a div with an id and class.
     * @returns A string.
     */
    menuIcon() {
        return `<div id="${this.idMenu}" class="menu-btn">
        <div class="menu-btn-burger"></div>
      </div>`;
    }
    toggleIconAndOpenDrawer() {
        var _a;
        (_a = document.getElementById(this.idMenu)) === null || _a === void 0 ? void 0 : _a.classList.toggle('open');
        this.openDrawer();
    }
}
//# sourceMappingURL=navbar-menu-icon.js.map